import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useLocation, useNavigate } from "react-router-dom";
import './App.css'
import { IframeProvider } from './context/IframeContext';
import Dashboard from './views/Dashboard';
import { setOrgId, setCountyIds } from "./utils/dashboardUtils";
import { MetricCategoriesProvider } from './context/MetricCategoriesContext';
import { LayersProvider } from './context/LayersContext';
import { MetadataProvider } from './context/MetadataContext';
import Storymap from './views/Storymap';
import { OrgProvider, useOrgContext } from './context/OrgIdContext';
import MapItemDetails from './views/MapItemDetails';
import { CountyFipsProvider } from './context/CountyFipsContext';
import SlideoutMapItemDetails from './views/SlideoutMapItemDetails';
import { ParcelProvider } from './context/ParcelContext';
import ParcelsPage from './components/parcels/ParcelsPage';
import ParcelDetailPage from './components/parcels/detail/ParcelDetailPage';

function App() {

  // for now, commerceorigin can be set to 8080
  //const allowedOrigin = "*";
  // state to track if the message has been sent to the parent application
  const [messageSent, setMessageSent] = useState(false);

  useEffect(() => {

    // If app is loaded within an iframe, send a "ready" message to the parent window
    if (!messageSent && window.parent !== window) {
      window.parent.postMessage({ message: "ready" }, "*");
      setMessageSent(true);
    }

    // Iframe events
    window.addEventListener("message", receiveMessage, false);

    return () => {
      // Cleanup event listener when component unmounts
      window.removeEventListener("message", receiveMessage);
    };
  }, [messageSent]);

  // Receive message - process Iframe requests
  function receiveMessage(event: MessageEvent) {
    event.preventDefault();

    if (event.data.message !== undefined) {
      switch (event.data.message) {
        case "update":
          setOrgId(event.data.params.organization_id || 12);

          if(event.data.params.area_view?.geo_details != undefined){
            console.log("checking for counties: ", event.data);
            var counties = event.data.params.area_view?.geo_details?.find((x: any) => x.lod === "county");
            console.log("found counties: ", counties);
            setCountyIds(counties?.ids ?? '');
          }

          break;
        case "process-token":
          handleToken(event.data.params.token);
          break;
      }
    }
  }

  // handleToken - Process the token received from parent window
  function handleToken(token: any) {
    // Log our token for now
    console.log("Received token:", token);
  };

  // Route redirection for federal way parcel tool
  function LocationRouteRedirector() {
    const { locationId, isReady } = useOrgContext();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      if (!isReady) return;

      const isDashboardRoute =
        location.pathname === "/" ||
        location.pathname === "/dashboard" ||
        location.pathname.startsWith("/dashboard/");

      if (locationId === "federalway" && isDashboardRoute) {
        navigate("/parcels", { replace: true });
      }
    }, [isReady, locationId, location.pathname, navigate]);

    return null;
  }


  return (
    <IframeProvider>
      <OrgProvider>
        <CountyFipsProvider>
          <MetricCategoriesProvider>
            <MetadataProvider>
              <LayersProvider>
                <ParcelProvider>
                  <Router>
                    <LocationRouteRedirector/>
                    <Routes>
                      <Route path="/" element={<Dashboard/>} />
                      {/* Dashboard Content */}
                      <Route path="/dashboard/:tab" element={<Dashboard/>}/>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/storymap" element={<Storymap />}/>
                      {/* Landing Page for Mapped Item Points */}
                      <Route path="/mapitemdetails" element={<MapItemDetails/>}/>
                      <Route path="/slideoutmapitemdetails" element={<SlideoutMapItemDetails/>}/>

                      {/* Parcels */}
                      <Route path="/parcels" element={<ParcelsPage />} />
                      <Route path="/parcels/:pin" element={<ParcelDetailPage />} />
                    </Routes>
                  </Router>
                </ParcelProvider>
              </LayersProvider>
            </MetadataProvider>
          </MetricCategoriesProvider>
        </CountyFipsProvider>
      </OrgProvider>
    </IframeProvider>
  )
}

export default App
